import { render, staticRenderFns } from "./HomeFeaturedStore.vue?vue&type=template&id=1894d631&scoped=true&"
import script from "./HomeFeaturedStore.vue?vue&type=script&lang=js&"
export * from "./HomeFeaturedStore.vue?vue&type=script&lang=js&"
import style0 from "./HomeFeaturedStore.vue?vue&type=style&index=0&id=1894d631&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1894d631",
  null
  
)

export default component.exports